import React from "react";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import Switch from "../../Switch/Switch";
import DateHelper from "../../DateHelper/DateHelper";
import { isAfter, startOfDay } from "date-fns";

class ReservationSegmentBuilderGuestTypes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    if (
      this.props.reservation_segment.guest_types &&
      this.props.reservation_segment.guest_types.length > 0
    ) {
      var guest_types = this.props.reservation_segment.guest_types
        .sort((a, b) => a.position - b.position)
        .map(function (guest_type, index) {
          return (
            <div
              className="row guest-type-form"
              key={`${guest_type.id}${index}`}
            >
              <div className="col-sm">
                <div className="name">
                  {guest_type.name} ({self.renderAgeRange(guest_type)})
                </div>
              </div>
              <div className="col-sm">
                {
                  self.props.read_only ?
                    <span className="number-of-guests">{self.getGuestCount(guest_type.id)}</span>
                  :
                    <NumberSpinner
                      name={guest_type.id}
                      onChange={self.props.onChangeGuestTypeCount}
                      value={self.getGuestCount(guest_type.id)}
                      max={self.calculateMaxGuests(guest_type.id)}
                    />
                }
              </div>
            </div>
          );
        });
    } else if (this.props.guest_types && this.props.guest_types.length > 0) {
      var guest_types = this.props.guest_types
        .sort((a, b) => a.position - b.position)
        .map(function (guest_type, index) {
          var number_of_guests = 0;

          self.props.reservation_segment.reservation_segment_guest_types.map(
            (rsgt) => {
              if (rsgt.guest_type_id == guest_type.id) {
                number_of_guests = rsgt.number_of_guests;
              }
            }
          );
          if (number_of_guests != 0) {
            return (
              <div
                className="row guest-type-form"
                key={`${guest_type.id}${index}`}
              >
                <div className="col-sm guest-number-name-wrapper">
                  <span className="name">{guest_type.name}</span>
                </div>
                {!self.props.read_only ? (
                  <div>
                    <div className="col-sm">
                      <NumberSpinner
                        name={guest_type.id}
                        onChange={self.props.onChangeGuestTypeCount}
                        value={self.getGuestCount(guest_type.id)}
                        max={self.calculateMaxGuests(guest_type.id)}
                      />
                    </div>
                  </div>
                ) : (
                  <span className="number-of-guests">{number_of_guests}</span>
                )}
              </div>
            );
          }
        });
    }

    return (
      <div className="row">
        <div className="col-sm-12">
          <label>{I18n.t("guest_types")}</label>
          {this.props.reservation_segment.guest_types &&
          this.props.reservation_segment.guest_types.length > 0 ? (
            <p>
              {I18n.t("max_occupancy_reached", {
                max_occupancy:
                  this.props.reservation_segment.room_type.maximum_occupancy,
              })}
            </p>
          ) : null}
          {guest_types}
        </div>
        {/* {(this.props.reservation_segment.status == "checked_in" &&
          isAfter(
            startOfDay(new Date()),
            startOfDay(
              DateHelper.parseDateFromBackend(
                this.props.reservation_segment.check_in_date
              )
            )
          ) &&
          this.props.new_folio_items &&
          this.props.new_folio_items.length > 0 &&
          this.props.reservation_segment.rate &&
          this.props.reservation_segment.rate.id !=
            this.props.original_reservation_segment.rate.id &&
          this.props.reservation_segment.room_type &&
          this.props.original_reservation_segment.room_type &&
          this.props.reservation_segment.room_type.id ===
            this.props.original_reservation_segment.room_type.id) ||
        (this.props.reservation_segment.status == "checked_in" &&
          isAfter(
            startOfDay(new Date()),
            startOfDay(
              DateHelper.parseDateFromBackend(
                this.props.reservation_segment.check_in_date
              )
            )
          ) &&
          this.props.new_folio_items &&
          this.props.new_folio_items.length > 0 &&
          this.props.reservation_segment.number_of_guests !=
            this.props.original_reservation_segment.number_of_guests &&
          this.props.reservation_segment.room_type &&
          this.props.original_reservation_segment.room_type &&
          this.props.reservation_segment.room_type.id ===
            this.props.original_reservation_segment.room_type.id) ? (
          <div className="col-sm-3">
            <label>{I18n.t("retroactive")} </label>
            {console.log('retro', this.props)}
            <Switch
              value={this.props.retroactive}
              onChange={this.props.onChangeRetroactive}
              onText='yes'
              offText='no'
            />
          </div>
        ) : null} */}
      </div>
    );
  }

  renderAgeRange(guest_type) {
    if (
      guest_type.maximum_age == null ||
      typeof guest_type.maximum_age == "undefined"
    ) {
      return <span>{guest_type.minimum_age}+</span>;
    } else {
      return (
        <span>
          {guest_type.minimum_age} &ndash; {guest_type.maximum_age}
        </span>
      );
    }
  }

  getGuestCount(guest_type_id) {
    if (this.props.reservation_segment.reservation_segment_guest_types) {
      for (
        var i = 0,
          ilen =
            this.props.reservation_segment.reservation_segment_guest_types
              .length;
        i < ilen;
        i++
      ) {
        if (
          this.props.reservation_segment.reservation_segment_guest_types[i]
            .guest_type_id == guest_type_id
        ) {
          return parseInt(
            this.props.reservation_segment.reservation_segment_guest_types[i]
              .number_of_guests
          );
        }
      }
    }
  }

  calculateMaxGuests(guest_type_id) {
    var room_type = this.props.reservation_segment.room_type;
    var total_guest_count = 0;
    if (this.props.reservation_segment.reservation_segment_guest_types) {
      for (
        var i = 0,
          ilen =
            this.props.reservation_segment.reservation_segment_guest_types
              .length;
        i < ilen;
        i++
      ) {
        if (
          this.props.reservation_segment.reservation_segment_guest_types[i]
            .guest_type_id == guest_type_id
        ) {
          // ignore if the guest_type_id matches
        } else {
          total_guest_count =
            total_guest_count +
            parseInt(
              this.props.reservation_segment.reservation_segment_guest_types[i]
                .number_of_guests
            );
        }
      }
    }
    return (
      this.props.reservation_segment.room_type.maximum_occupancy -
      total_guest_count
    );
  }

  isMaxOccupancyReached() {
    var room_type = this.props.reservation_segment.room_type;
    var total_guest_count = 0;

    if (this.props.reservation_segment.reservation_segment_guest_types) {
      for (
        var i = 0,
          ilen =
            this.props.reservation_segment.reservation_segment_guest_types
              .length;
        i < ilen;
        i++
      ) {
        total_guest_count =
          total_guest_count +
          parseInt(
            this.props.reservation_segment.reservation_segment_guest_types[i]
              .number_of_guests
          );
      }
    }

    if (room_type && room_type.maximum_occupancy > 0) {
      return room_type.maximum_occupancy == total_guest_count;
    } else {
      return false;
    }
  }
}

export default ReservationSegmentBuilderGuestTypes;
